import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultImage from "../Component/img/event1.jfif";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import blog from "../Component/img/blog.webp";

const Blog = () => {
  return (
    <>
      <NavbarVisitor />

<div className="container-fluid">
<div className="my-2  text-start">
        <span className="text-muted txt4">Home</span>
        <span className="text-muted txt4"> / </span>
        <span className="text-muted txt4">General</span>
        <span className="text-muted txt4"> / </span>
        <span className="txt4 txt5">
          All About Jigsaw by Black+Decker & Dewalt
        </span>
      </div>
</div>
      

      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="mb-3">
              <img src={blog} alt="" className="img-fluid blg2" />
            </div>

            <div>
              <h5 className="txt1">General, Power Tools</h5>
              <h1 className="txt7 mb-2">
                All About Jigsaw by Black+Decker & Dewalt
              </h1>
            </div>

            <h6 className="txt4">
              <span className="txt5">Evventoz</span>{" "}
              <span className="text-muted">/ March 25, 2021</span>
            </h6>

            <p className="txt3 mb-3">
              A jigsaw is the best-selling and valued power tool that is used in
              a vast range of cutting applications. A good power tool can save
              half of the effort when it comes to achieving adequate cuts with a
              jigsaw. Black+Decker & Dewalt offers many products to the market
              when it comes to jigsaw and jigsaw blades. So, choosing the right
              one may become a difficult task for some people.
            </p>
          </div>
          <div className="col-md-4">
          <div>
              <h3 className="txt6 jk widget-title">POPULAR TAGS</h3>

              <div className="text-start tag-container">
                <span className="tag1 me-2">B2B</span>
                <span className="tag1 me-2">B2B</span>
                <span className="tag1 me-2">B2B</span>
                <span className="tag1 me-2">B2B</span>
                <span className="tag1 me-2">B2B</span>
                <span className="tag1 me-2">B2B</span>
              </div>
            </div>
          </div>
        </div>
      </div>

       

      <Footer />
    </>
  );
};

export default Blog;
